module.exports = __webpack_public_path__ + "img/Super-Feedback.7a51d185.png";